export default __webpack_public_path__ + "static/media/16.e2def89d.jpg";